





























































































































































































import { API_EXPORT_TASK_SYNC, API_BUILDING_LIST } from "@/configs/Apis";
import { MSG_EXPORT_FILE_NOTFOUND } from "@/configs/Consts";
import formatters from "@/utils/ColumnFormater";
import {
  hasPermission,
  isEmpty,
  isEmptyOrWhiteSpace,
  mergeColumns,
  showConfirm,
  showError,
  showSuccess,
  showWarning,
} from "@/utils/Common";
import { Fetcher as Ajax } from "@/utils/Request";
import BuildingForm from "@/views/building/subviews/BuildingForm.vue";
import { TableColumn } from "element-ui/types/table-column";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {
    BuildingForm,
  },
})
export default class BuildingIndex extends Vue {
  nodeQueryData = "";
  queryData: any = { code: "" };

  addBuildingFormDialogVisible = false;
  buildingItem: any = { id: 0 };

  hasSelectedItems = false;

  queryStr = "";
  loadData = false;

  showSearch = false;

  hasPerm(checkedPerm: string) {
    return hasPermission(this.$store.getters["user/user"] || {}, checkedPerm);
  }

  get treeData() {
    const module = this.$store.state.building;
    if (!module) {
      return null;
    }
    return module.buildingTree;
  }

  onTreeNodeClick(index: string) {
    if (isEmptyOrWhiteSpace(index)) {
      return;
    }
    const parts = index.split("-");
    let nodeData: any = null;
    if (parts.length === 1) {
      nodeData = this.treeData[parts[0]];
    } else {
      nodeData = this.treeData[parts[0]].children[parts[1]];
    }
    if (!nodeData) {
      return;
    }
    this.nodeQueryData = JSON.stringify(nodeData.buildingFilter || {});
    // this.onQueryChanged();
  }

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_BUILDING_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  createTableColumns() {
    const defaultColumns: Array<TableColumnOption> = [
      { prop: "code", display: "房号", width: 120 },
      { prop: "area", display: "面积", width: 100 },
      { prop: "checkInDate", display: "入住日期", width: 110 },
      { prop: "checkInCount", display: "入住人数", width: 110 },
      { prop: "ownerName", display: "户主姓名", width: 120 },
      { prop: "ownerIdCard", display: "身份证", width: 120 },
      { prop: "ownerPhone", display: "电话", width: 120 },
      { prop: "ownerGender", display: "性别", width: 80 },
      { prop: "elecNo", display: "电表号", width: 110 },
      { prop: "waterNo", display: "水表号", width: 110 },
      { prop: "gasNo", display: "燃气表号", width: 110 },
      { prop: "remark", display: "备注" },
    ];
    this.$store
      .dispatch("building/getListLayout", { listName: "BUILDING" })
      .then((layout) => {
        const columns = mergeColumns(
          JSON.parse(layout || "[]"),
          defaultColumns
        );
        this.applyColumnFormatters(columns);
        return columns;
      })
      .then((columns) => this.$store.dispatch("building/setColumns", columns));
  }

  applyColumnFormatters(columns: Array<TableColumnOption>) {
    const fmers = {
      ownerGender: this.colFormatters.formatGender.bind(this),
    };
    if (!columns || !columns.length) {
      return;
    }
    columns.forEach((option) => {
      if (!Object.prototype.hasOwnProperty.call(fmers, option.prop)) {
        return;
      }
      option.formatter = (fmers as any)[option.prop];
    });
  }

  reloadTreeAndData() {
    this.loadBuildingTree();
    this.searchData();
  }

  onModuleRegistered() {
    this.$nextTick()
      .then(() => this.createTableColumns())
      .then(() => {
        this.loadBuildingTree();
        this.onSearchConditionChange();
      });
  }

  loadBuildingTree() {
    return this.$store.dispatch("building/getBuildingTree");
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }

  onSearchConditionChange() {
    const params: { [key: string]: any } = {};
    if (!isEmptyOrWhiteSpace(this.nodeQueryData)) {
      const nodeFilter = JSON.parse(this.nodeQueryData);
      Object.keys(nodeFilter).forEach(
        (name) => (params[name] = nodeFilter[name])
      );
    }
    if (!isEmptyOrWhiteSpace(this.queryData.code)) {
      params.code = this.queryData.code;
    }
    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      this.queryStr = "{}";
      return;
    }
    if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  @Watch("nodeQueryData")
  onNodeQueryDataChange() {
    this.queryData = { code: "" };
    this.onSearchConditionChange();
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  addBuilding() {
    this.buildingItem = { id: 0, checkInDate: "2017-10-10" };
    this.addBuildingFormDialogVisible = true;
  }

  addBuildingSuccess() {
    this.addBuildingFormDialogVisible = false;
    this.reloadTreeAndData();
    this.buildingItem = { id: 0 };
  }

  editBuilding() {
    const selectedRows = (this.$refs.buildinggrid as any).getSelectedDataRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请选择一条数据");
      return;
    }
    this.buildingItem = JSON.parse(JSON.stringify(selectedRows[0]));
    this.addBuildingFormDialogVisible = true;
  }

  exportData(cmd: string) {
    let dataFilter: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.buildinggrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      dataFilter.selectedIds = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        dataFilter = JSON.parse(this.queryStr);
      }
    }
    const fieldParams: Array<any> = (
      (this.$refs.buildinggrid as any).columns || []
    )
      .filter((column: any) => !column.hidden)
      .map((column: any) => {
        return {
          field: column.prop,
          label: column.display,
          width: column.width || 30,
        };
      });
    const params: any = {
      dataType: "Building",
      fieldParams: JSON.stringify(fieldParams),
      dataFilter: JSON.stringify(dataFilter),
    };
    Ajax.queryData(API_EXPORT_TASK_SYNC, params)
      .then((task: any) => {
        const url = task.resultUrl || "";
        if (isEmpty(url)) {
          showWarning(MSG_EXPORT_FILE_NOTFOUND);
          return;
        }
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        if (a.parentNode) {
          a.parentNode.removeChild(a);
        }
      })
      .catch(({ message }) => showError(message));
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(command: string, data: any, event: MouseEvent) {}

  onColumnConfiged({
    data = [],
    hidden = [],
  }: {
    data: Array<TableColumnOption>;
    hidden: Array<TableColumnOption>;
  }) {
    const newData: Array<TableColumnOption> = JSON.parse(JSON.stringify(data));
    const newHidden: Array<TableColumnOption> = JSON.parse(
      JSON.stringify(hidden)
    );
    // 删除属性
    newData.forEach((item) => delete item.hidden);
    if (hidden && hidden.length) {
      newData.push(
        ...newHidden.map((val) => Object.assign(val, { hidden: true }))
      );
    }
    this.$store
      .dispatch("building/saveListLayout", {
        listName: "USER",
        layout: JSON.stringify(newData),
      })
      .then(() => this.$store.dispatch("building/setColumns", []))
      .then(() => this.createTableColumns())
      .catch(({ message }) => showError(message));
  }

  onColumnResize(newWidth: number, column: TableColumn) {
    this.$store.dispatch("building/setColumnWidth", {
      listName: "building",
      column: column.property,
      newWidth,
    });
  }

  openColumnConfig() {
    const grid = this.$refs.buildinggrid as any;
    grid.openColumnConfig();
  }

  onTableDataLoaded() {
    //
  }

  openSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  batchDeleteData(cmd: string) {
    let params: any = {};
    let msg = "当前列表";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.buildinggrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      params.selectedIds = selectedRows;
      msg = `${selectedRows.length} 条数据`;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    showConfirm(`是否确认删除 ${msg}？`).then(() => {
      this.$store
        .dispatch("building/deleteBuilding", params)
        .then(() => {
          showSuccess("删除成功");
          this.reloadTreeAndData();
        })
        .catch(({ message }) => showError(message));
    });
  }
}
